// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"gz-z","smallCardRow":"hz-z","largeCardRow":"iz-z","productSearchRow":"jz-z","curatedRow":"kz-z"};